import styled from "styled-components";

export const CommentMoreContainer = styled.div`
  /* margin-top: -17px; */
  position: relative;
  width: 100%;

  & > div {
    position: absolute;
    right: 0;
    width: 67.77%;

    background-color: rgba(237, 237, 237, 0.8);
    border-radius: 12px;
    box-sizing: border-box;

    filter: drop-shadow(0px 8px 64px rgba(0, 0, 0, 0.08));
    backdrop-filter: blur(80px);

    & div {
      padding: 11px 16px;
      font-weight: 500;
      cursor: pointer;
      color: #000;

      border-bottom: 0.5px solid rgba(60, 60, 67, 0.36);
    }

    & :last-child {
      border: none;
    }
  }
`;
